import { el } from 'redom';

import CodeEditorInputBoxRow from 'generics/components/code-editor-input-box/row';

import './index.scss';

class AdvancedFormSettings {

  constructor(configuration) {

    this.detailsEditor = configuration.detailsEditor;
    this.data = configuration.data;
    this.handleBuilder = configuration.handleBuilder || this.defaultHandlerBuilder;
    this.onChange = configuration.onChange;

    this.apiEndpointInput = null;
    this.takeActionInputBoxRow = null;

    this.el = el('.advanced-form-settings-main', [
      this.renderTakeActionInputRow()
    ]);

  }

  handleAPIEndpointInputClick() {

    this.takeActionInputBoxRow.input.focus();

  }

  renderTakeActionInputRow() {

    this.takeActionInputBoxRow = new CodeEditorInputBoxRow({
      placeholder: `
      function clickHandler(event) {
        console.log('Button clicked!');
      }`,
      label: 'Take action',
      value: this.data.clickHandler || '',
      onChange: this.handleTakeActionChange.bind(this)
    });

    return this.takeActionInputBoxRow;

  }

  handleTakeActionChange(code) {

    this.data.clickHandler = code;
    this.detailsEditor.refreshRedirectPath();
    this.onChange(this.data);

  }

  defaultHandlerBuilder(path) {

    return `
    function clickHandler(event) {
      window.location.href = '${path}';
    }`;
  }

  buildClickHandlerForPath(path) {

    const clickHandler = this.handleBuilder(path);
    this.data.clickHandler = clickHandler;
    this.takeActionInputBoxRow.input.setValue(this.data.clickHandler);

  }

}

export default AdvancedFormSettings;